
import { supabase } from "@/integrations/supabase/client";
import { KolDataWithDates } from '@/types/table';

export interface DataQualityTableProps {
  onDataChange?: () => void;
  groupByPic?: boolean;
}

export interface GroupedData {
  [picName: string]: KolDataWithDates[];
}

export const updateKolTrackerRow = async (
  rowId: string, 
  field: keyof KolDataWithDates, 
  value: any
): Promise<void> => {
  const updateData: any = {
    [field]: value
  };
  
  // Handle posting_date field specially to avoid timezone issues
  if (field === 'posting_date' && value instanceof Date) {
    const year = value.getFullYear();
    const month = String(value.getMonth() + 1).padStart(2, '0');
    const day = String(value.getDate()).padStart(2, '0');
    updateData[field] = `${year}-${month}-${day}`;
  }
  
  const { error } = await supabase
    .from('kol_tracker')
    .update(updateData)
    .eq('id', rowId);

  if (error) throw error;
};

export const transformKolTrackerData = (data: any[]): KolDataWithDates[] => {
  return data.map(item => ({
    ...item,
    business_unit: item.business_unit || '',
    posting_date: item.posting_date ? new Date(item.posting_date + 'T00:00:00') : null,
    updated_date: item.updated_date ? new Date(item.updated_date) : null,
    pic: Array.isArray(item.pic) ? item.pic : (item.pic ? [item.pic] : []),
    campaign_bu: Array.isArray(item.campaign_bu) ? item.campaign_bu : (item.campaign_bu ? [item.campaign_bu] : []),
    created_at: item.created_at ? new Date(item.created_at) : null,
    updated_at: item.updated_at ? new Date(item.updated_at) : null,
  }));
};

export const groupDataByPic = (data: KolDataWithDates[]): GroupedData => {
  const grouped: GroupedData = {};
  
  data.forEach(item => {
    // If item has no PIC or empty PIC array, assign to "No Assign PIC"
    if (!item.pic || !Array.isArray(item.pic) || item.pic.length === 0) {
      if (!grouped['No Assign PIC']) {
        grouped['No Assign PIC'] = [];
      }
      grouped['No Assign PIC'].push(item);
    } else {
      // For each PIC in the array, add the item to that PIC's group
      item.pic.forEach(picName => {
        if (picName && picName.trim()) {
          if (!grouped[picName]) {
            grouped[picName] = [];
          }
          grouped[picName].push(item);
        }
      });
    }
  });
  
  return grouped;
};
